import React, { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { ChatPanel } from "./ChatPanel";
import { useRouterState } from "@tanstack/react-router";

export function CustomerChatWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  
  // Don't show on admin pages
  const isAdminPage = pathname.startsWith("/admin");

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 500);
    return () => clearTimeout(t);
  }, []);

  if (isAdminPage) return null;

  return (
    <>
      <div
        className={cn(
          "transition-all duration-500 ease-in-out pr-4 sm:pr-6 pointer-events-auto",
          mounted ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0",
          isOpen ? "scale-0 opacity-0 pointer-events-none" : "scale-100 opacity-100 pointer-events-auto"
        )}
      >
        <button
          onClick={() => setIsOpen(true)}
          aria-label="Open Healthy Kitchen Chat"
          className="group relative flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-2xl transition-transform hover:scale-110 active:scale-95"
        >
          <MessageCircle className="h-6 w-6 transition-transform group-hover:rotate-12" />
          <span className="absolute -top-1 -right-1 flex h-3 w-3">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary opacity-75"></span>
            <span className="relative inline-flex h-3 w-3 rounded-full bg-primary border-2 border-white"></span>
          </span>
        </button>
        
        <span className="absolute right-full mr-4 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-md bg-white/90 px-3 py-1.5 text-xs font-bold tracking-wider text-primary shadow-sm border border-primary/10 backdrop-blur-sm pointer-events-none hidden sm:block">
          Need help? Chat with us!
        </span>
      </div>

      <ChatPanel isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
